import MixBarChartData from "../charts-components/mix-bar-chart";
import NewPieChartComponent from "../charts-components/new-pie-chart";
import NewSalesChart from "../charts-components/new-sales-chart";
import { CollectionDayRate } from "../charts-components/collection-day-rate";

// Dashboard charts grid: bar, pie, collection, and sales breakdown cards
export default function NewCharts() {
  return (
    <div className="grid grid-cols-3 items-stretch gap-4 mt-4 smallLaptop:grid-cols-2">
      <div className="col-span-2 flex">
        <MixBarChartData />
      </div>

      <NewPieChartComponent />

      <div className="col-span-2 flex">
        <CollectionDayRate />
      </div>

      <div className="flex flex-col h-full px-6 py-5 bg-surface border border-edge rounded-2xl shadow-card">
        <h1 className="text-[19px] text-heading-color font-semibold tracking-tight">
          Chase Types
        </h1>
        <p className="text-[13px] text-light-gray font-medium mt-1">
          Last 6 months
        </p>

        <div className="grid flex-1 min-h-[360px] grid-cols-2 grid-rows-2 gap-3 mt-5">
          <NewSalesChart type="Sales"></NewSalesChart>
          <NewSalesChart type="Renewals"></NewSalesChart>
          <NewSalesChart type="Standard"></NewSalesChart>
          <NewSalesChart type="Non-Standard"></NewSalesChart>
        </div>
      </div>
    </div>
  );
}
